import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import { apiKey } from "../config/config";
import Table from "../components/Table";
import Receipt from "../components/Receipt";

function TransactionReports({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin
  ).branch_id;

  const [reports, setReports] = useState([]);
  const [filter, setFilter] = useState("");
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState("");
  const [entryType, setEntryType] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [branch, setBranch] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  function convertDateFormat(inputDate) {
    if (!inputDate) return "N/A";
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return dateObject.toLocaleDateString("en-GB", options);
  }

  const getTransactionLabel = (type) => {
    switch (type) {
      case "contract_creation":
        return lang["Contract Creation"] || "Contract Creation";
      case "payment":
        return lang["Payment"] || "Payment";
      case "expense":
        return lang["Expense"] || "Expense";
      case "investor_deposit":
      case "deposit":
        return lang["Investor Deposit"] || "Investor Deposit";
      case "investor_withdrawal":
      case "withdraw":
        return lang["Investor Withdrawal"] || "Investor Withdrawal";
      case "investor_percentage_withdrawal":
        return lang["Investor Percentage Withdrawal"] || "Percentage Withdrawal";
      case "card_purchase":
        return lang["Card Purchase"] || "Card Purchase";
      case "card_sale":
        return lang["Card Sale"] || "Card Sale";
      default:
        return type || "N/A";
    }
  };

  const columns = [
    {
      header: lang.Investor || "Party / Investor",
      accessorKey: "FullName",
      // footer: (info) => lang["Total"] || "Total",
    },
    {
      header: lang.Type || "Transaction Type",
      accessorKey: "transaction_type",
      cell: (row) => {
        const val = row.row.original.transaction_type || row.row.original.type;
        return (
          <span className="badge bg-secondary px-2 py-1" style={{ fontSize: "0.82rem" }}>
            {getTransactionLabel(val)}
          </span>
        );
      },
    },
    {
      header: lang["Statement"] || "Statement",
      accessorKey: "statement",
      cell: (row) => row.row.original.statement || "-",
    },
    {
      header: lang["Credit/Debit"] || "Credit / Debit",
      accessorKey: "entry_type",
      cell: (row) => {
        const isCredit =
          row.row.original.entry_type === "credit" ||
          row.row.original.type === "deposit";
        return isCredit ? (
          <span
            className="px-2 py-1 rounded fw-bold"
            style={{ backgroundColor: "#e6f4ea", color: "#137333", fontSize: "0.85rem" }}
          >
            + Credit
          </span>
        ) : (
          <span
            className="px-2 py-1 rounded fw-bold"
            style={{ backgroundColor: "#fce8e6", color: "#c5221f", fontSize: "0.85rem" }}
          >
            - Debit
          </span>
        );
      },
    },
    {
      header: lang.Amount || "Amount",
      accessorKey: "amount",
      // footer: (info) => {
      //   const total = info.table
      //     .getFilteredRowModel()
      //     .rows.reduce((sum, row) => {
      //       const { amount } = row.original;
      //       return sum + Number(amount || 0);
      //     }, 0);
      //   return `${total.toFixed(2)}`;
      // },
    },
    {
      header: lang["Balance After"] || "Balance After",
      accessorKey: "balance_after",
      cell: (row) => {
        const bal = row.row.original.balance_after;
        return bal !== undefined && bal !== null
          ? `${Number(bal).toFixed(2)}`
          : "-";
      },
    },
    {
      header: lang.date || "Date",
      accessorKey: "date",
      cell: (row) => convertDateFormat(row.row.original.date),
    },
    {
      header: lang["Added By"] || "Added By",
      accessorKey: "created_by",
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <Receipt
          lang={lang}
          receiptData={row.row.original}
          branchData={branch}
          idx={row.row.index}
        />
      ),
    },
  ];

  useEffect(() => {
    if (filter !== "from_to") {
      setFrom();
      setTo();
    }
    if (branchId) {
      axios
        .get(apiKey + "/transaction-reports", {
          params: {
            branch_id: branchId,
            filter,
            investor_id: investor,
            entry_type: entryType,
            transaction_type: transactionType,
            from,
            to,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setReports(res.data.result || []);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, filter, investor, entryType, transactionType, from, to, token]);

  useEffect(() => {
    if (branchId) {
      axios
        .get(apiKey + "/investor", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInvestorList(res.data.result || []);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, token]);

  useEffect(() => {
    if (branchId) {
      axios
        .get(`${apiKey}/get-dealer/${branchId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setBranch(res.data.result?.[0]);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, token]);

  return (
    <main className="main" id="main">
      <div className="pagetitle">
        <h1>{lang.Reports || "Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
            <li className="breadcrumb-item active">
              {lang.transaction_report || "Transaction Log (Financial)"}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="mt-3 mb-3">
                  <div className="rr mb-3">
                    {lang.transaction_report || "Transaction Log (Financial Transactions)"}
                  </div>
                  <div className="row justify-content-end gap-2 px-3">
                    {filter === "from_to" && (
                      <>
                        <div className="col-md-2 col-12 custom-datepicker">
                          <DatePicker
                            placeholder={lang["from_text"] || "From"}
                            style={{ height: "38px", width: "100%" }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setFrom(dateObject);
                            }}
                          />
                        </div>
                        <div className="col-md-2 col-12 custom-datepicker">
                          <DatePicker
                            className="btn-exportform-control w-100"
                            placeholder={lang["to_text"] || "To"}
                            style={{ height: "38px", width: "100%" }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setTo(dateObject);
                            }}
                          />
                        </div>
                      </>
                    )}

                    {/* Date Range Filter */}
                    <select
                      onChange={(e) => setFilter(e.target.value)}
                      className="btn-export col-md-2 col-12"
                      name="time"
                      id="time"
                      value={filter}
                    >
                      <option value="">{lang.All_Time || "All Time"}</option>
                      <option value="today">{lang.Today || "Today"}</option>
                      <option value="this_week">{lang.This_Week || "This Week"}</option>
                      <option value="this_month">{lang.This_Month || "This Month"}</option>
                      <option value="this_year">{lang.This_Year || "This Year"}</option>
                      <option value="from_to">{lang["From To"] || "From To"}</option>
                    </select>

                    {/* Credit / Debit Filter */}
                    <select
                      onChange={(e) => setEntryType(e.target.value)}
                      className="btn-export col-md-2 col-12"
                      name="entryType"
                      id="entryType"
                      value={entryType}
                    >
                      <option value="">{lang["All Types"] || "All (Credit & Debit)"}</option>
                      <option value="credit">{lang["Credit"] || "Credit (+)"}</option>
                      <option value="debit">{lang["Debit"] || "Debit (-)"}</option>
                    </select>

                    {/* Transaction Operation Filter */}
                    <select
                      onChange={(e) => setTransactionType(e.target.value)}
                      className="btn-export col-md-2 col-12"
                      name="trxType"
                      id="trxType"
                      value={transactionType}
                    >
                      <option value="">{lang["All Operations"] || "All Operations"}</option>
                      <option value="contract_creation">{lang["Contract Creation"] || "Contract Creation"}</option>
                      <option value="payment">{lang["Payment"] || "Payment"}</option>
                      <option value="expense">{lang["Expense"] || "Expense"}</option>
                      <option value="investor_deposit">{lang["Investor Deposit"] || "Investor Deposit"}</option>
                      <option value="investor_withdrawal">{lang["Investor Withdrawal"] || "Investor Withdrawal"}</option>
                      <option value="investor_percentage_withdrawal">{lang["Percentage Withdrawal"] || "Percentage Withdrawal"}</option>
                      <option value="card_purchase">{lang["Card Purchase"] || "Card Purchase"}</option>
                      <option value="card_sale">{lang["Card Sale"] || "Card Sale"}</option>
                    </select>

                    {/* Investor Filter */}
                    <select
                      onChange={(e) => setInvestor(e.target.value)}
                      className="btn-export col-md-2 col-12"
                      name="inv"
                      id="inv"
                      value={investor}
                    >
                      <option value="">{lang.all_investors || "All Investors"}</option>
                      {investorList.map((invItem, index) => (
                        <option key={index} value={invItem.id}>
                          {invItem.FullName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="d-flex mt-3 mb-3">
                  <Table
                    lang={lang}
                    data={reports}
                    columns={columns}
                    // footer={true}
                    exportOption={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TransactionReports;
